// extracted by mini-css-extract-plugin
export var chip = "_me-0";
export var icon = "_me-1";
export var remove = "_me-2";
export var removeIcon = "_me-3";